import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { PromoPopupService } from 'src/app/services/promotion/promo-popup.service';

/**
 * The header's way back to a running sale's popup: a pill in the sale's colours, shown to shops only
 * while a sale runs. Its name collapses to the discount on narrow screens.
 */
@Component({
  selector: 'app-promo-popup-trigger',
  standalone: true,
  imports: [TranslatePipe, MatIconModule],
  template: `
    @if (promotion(); as promotion) {
      <button
        type="button"
        class="flex h-8 items-center gap-1.5 rounded-full bg-[#111] px-3 text-xs font-bold uppercase leading-none text-[#ff7500] hover:opacity-90"
        (click)="open()"
        [attr.aria-label]="'promotion.' + promotion.campaign + '.show-offer' | translate"
        [title]="'promotion.' + promotion.campaign + '.show-offer' | translate"
        data-cy="promo-popup-trigger"
      >
        <mat-icon class="!h-4 !w-4 !text-base !leading-4">local_offer</mat-icon>
        <span class="hidden md:inline">{{ 'promotion.' + promotion.campaign + '.name' | translate }}</span>
        @if (promotion.maxPercentOff) {
          <span>−{{ promotion.maxPercentOff }}%</span>
        }
      </button>
    }
  `,
})
export class PromoPopupTriggerComponent {
  private readonly promoPopupService = inject(PromoPopupService);

  readonly promotion = toSignal(this.promoPopupService.livePromotion$, { initialValue: null });

  open() {
    this.promoPopupService.open();
  }
}
